import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";

export class ProgramTypesMultiSelectComponent implements IController {

  selectedProgramIds: any;
  ngPlaceholder: any;
  isDisabled: any;
  options: any;
  optionIds: string[];
  onChange: Function;

  public selectedText: any;
  public siteProgramTypes: any;
  public siteProgramTypesMap: any = {};


  constructor(private $mdPanel, private $element, private splitService) {
  }

  $onInit() {
    this.siteProgramTypes = this.splitService.getSiteProgramTypes();
    _.forEach(this.siteProgramTypes, programType => {
      this.siteProgramTypesMap[programType.id] = programType.type;
    })
    this._setSelectedText();
  };

  $onChanges(changes) {
    if (changes.selectedProgramIds && !changes.selectedProgramIds.isFirstChange()) {
      this._setSelectedText();
    }
  };

  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdsRef = this.selectedProgramIds || [];
    const ngPlaceholderRef = this.ngPlaceholder;
    const optionsRef = this.options;
    const optionIdsRef = this.optionIds;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-multi-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-ids="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-multi-select-filter-panel>',
      controller: function () {
        this.typeRef = 'programTypes';
        this.selectedIdsRef = selectedIdsRef;
        this.optionsRef = optionsRef;
        this.optionIdsRef = optionIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedProgramIds) => {
        if (selectedProgramIds === 'clickOutsideToClose' || selectedProgramIds === 'escapeToClose') {
          selectedProgramIds = selectedIdsRef;
        }

        this.onChange({programIds: selectedProgramIds});
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({programIds: []});
  }

  private _setSelectedText() {
    let string = '';
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext("2d");

    _.forEach(this.selectedProgramIds, (id, index) => {
      string += this.siteProgramTypesMap[id];
      if ((index + 1) < this.selectedProgramIds.length) {
        string += ', '
      }
    });

    const stringWidth = ctx.measureText(string).width;
    if (this.$element[0]?.clientWidth && (stringWidth + 80) >= (this.$element[0].clientWidth - 30)) {
      string = this.siteProgramTypesMap[this.selectedProgramIds[0]].type + ` +${this.selectedProgramIds.length - 1}`
    }
    this.selectedText = string;
  }


}

angular
  .module('bringoz.admin.commons')
  .component('programTypesMultiSelect', {
    bindings: {
      selectedProgramIds: '<?',
      options: '<?',
      optionIds: '<?',
      ngPlaceholder: '@?',
      isDisabled: '<?',
      onChange: '&'
    },
    template: require('./program-types-multi-select.html').default,
    controller: ProgramTypesMultiSelectComponent
  });
